"use client";

import { type ComponentProps } from "react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Icon, type IconName } from "@/components/ui/icon";
import { cn } from "@/lib/utils";

export function AvatarNameBadge({
  name,
  avatarUrl,
  fallbackIcon = "IconPeopleCircle",
  variant = "outline-muted",
  size = "sm",
  className,
  ...props
}: ComponentProps<typeof Badge> & {
  name: string;
  avatarUrl?: string | null;
  /**
   * Glyph shown when there is no avatar. Defaults to a person, but not
   * every actor is one — an automated or system-attributed row should
   * not wear a face.
   */
  fallbackIcon?: IconName;
}) {
  return (
    <Badge
      variant={variant}
      size={size}
      className={cn("rounded-sm", className)}
      {...props}
    >
      <Avatar className="size-3">
        <AvatarImage src={avatarUrl} alt="" />
        <AvatarFallback>
          <Icon
            name={fallbackIcon}
            size={8}
            aria-hidden="true"
            className="text-heading opacity-20"
          />
        </AvatarFallback>
      </Avatar>
      <span>{name}</span>
    </Badge>
  );
}
